export default "__VITE_ASSET__DQuQTdD2__"